import React from 'react';
import { Skeleton } from '@components/ui/skeleton';
const HeroBlockSkeleton: React.FC = () => {
  return <div className="max-w-[1920px] mb-5 md:mb-12 lg:mb-14 2xl:mb-16 mx-auto overflow-hidden px-4 md:px-8 2xl:px-4" data-sentry-component="HeroBlockSkeleton" data-sentry-source-file="HeroBlockSkeleton.tsx">
      <Skeleton className="w-full h-56 md:h-72 lg:h-80 2xl:h-[600px] animate-pulse" data-sentry-element="Skeleton" data-sentry-source-file="HeroBlockSkeleton.tsx" />
    </div>;
};
export default HeroBlockSkeleton;